import { prefixObjectValues } from '../utils';

const accountType = {
  provider: 'provider',
  employer: 'employer',
};

export default prefixObjectValues(accountType, 'registration');
